/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupno1Inputs */

const en_signupno1 = /** @type {(inputs: Signupno1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const de_signupno1 = /** @type {(inputs: Signupno1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Signupno1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupno1 = /** @type {((inputs?: Signupno1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupno1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupno1(inputs)
	return de_signupno1(inputs)
});
export { signupno1 as "signupNo" }